// 年度生产计划
import axios from 'axios'
import Vue from 'vue'
export default {
  name: 'annualPlan',
  namespaced: true,
  state: {
    year: '',
    department: {
      销售部: null,
      预处理车间: null,
      浸出车间: null,
      精炼车间: null,
      包装车间: null,
      其他车间: null
    },
    // 指标类型
    indexType: {
      进销产出指标: null,
      效率指标: null,
      质量指标: null,
      单耗指标: null,
      三废指标: null
    },
    planStep: {
      编制中: null,
      已发布: null
    },
    unitType: {},
    oilType: {}
  },
  getters: {
    getYear (state) {
      return state.year
    }
  },
  mutations: {
    changeYear (state, year) {
      state.year = year
    },
    changeDepartment (state, department) {
      state.department = department
    },
    changeIndexType (state, indexType) {
      state.indexType = indexType
    },
    changeUnitType (state, unitType) {
      state.unitType = unitType
    },
    changePlanStep (state, planStep) {
      state.planStep = planStep
    },
    changeOilType (state, oilType) {
      state.oilType = oilType
    }
  },
  actions: {
    loadAll: function (context) {
      axios.all([
        // 计划部门
        axios.post('/Enum/ValuesObject', null, {
          params: { enumType: 'AnnualPlanDepartment' }
        }),
        // 指标类型
        axios.post('/Enum/ValuesObject', null, {
          params: { enumType: 'AnnualPlanIndexType' }
        }),
        // 计量单位类型
        axios.post('/Enum/ValuesObject', null, {
          params: { enumType: 'UnitManageType' }
        }),
        // 计划状态类型
        axios.post('/Enum/ValuesObject', null, {
          params: { enumType: 'AnnualPlanStatus' }
        }),
        // 油品类型
        axios.post('/Enum/ValuesObject', null, {
          params: { enumType: 'OilType' }
        })
      ])
        .then(axios.spread((departmentResponse, indexResponse, unitResponse, planStatusResponse, oilTypeResponse) => {
          context.commit('changeDepartment', departmentResponse.data)
          context.commit('changeIndexType', indexResponse.data)
          context.commit('changeUnitType', unitResponse.data)
          context.commit('changePlanStep', planStatusResponse.data)
          context.commit('changeOilType', oilTypeResponse.data)
        })).catch((error) => {
          Vue.$message.error(error)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/annualPlan.js